<template>
    <div class="date-container d-flex flex-column">
        <span class="d-block text-4 font-weight-300">{{ formattedDate.day }}</span>
        <span class="d-block text-1 font-weight-300 text-uppercase"> {{ formattedDate.month }}</span>
    </div>
</template>

<script>
export default {
    props: {
        dateString: {
            type: String,
            required: true
        }
    },
    computed: {
        formattedDate() {
            if (!this.dateString) return { day: "", month: "" };
            const date = new Date(this.dateString);
            return {
                day: date.getDate().toString().padStart(2, '0'),
                month: date.toLocaleString('en-US', { month: 'short' }).toUpperCase()
            };
        }
    }
};
</script>

<style scoped>
.day {
    font-size: 20px;
}

.month {
    font-size: 14px;
}
</style>
